import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import TimePicker from '../../common/TimePicker'
import Checkbox from '../../common/Checkbox'

import * as Strings from './strings'

const WEEKDAYS = [
  { placeholder: 'Måndag', id: 'mo' },
  { placeholder: 'Tisdag', id: 'tu' },
  { placeholder: 'Onsdag', id: 'we' },
  { placeholder: 'Torsdag', id: 'th' },
  { placeholder: 'Fredag', id: 'fr' },
  { placeholder: 'Lördag', id: 'sa' },
  { placeholder: 'Söndag', id: 'su' }
]

class TimeModal extends Component {
  render() {
    const {
      show = true,
      hide,
      startTimeInput,
      endTimeInput,
      classes,
      header,
      information,
      onDone,
      onChangeStartTimeInput,
      onChangeEndTimeInput,
      errorStartTime,
      errorEndTime,
      loading = false,
      errorMessage = '',
      days = [],
      showDays,
      onChangeDays
    } = this.props

    return (
      <Dialog open={show} aria-labelledby={'form-dialog-title'}>
        <DialogTitle id={'form-dialog-title'}>{header}</DialogTitle>
        <DialogContent>
          <DialogContentText>{information}</DialogContentText>
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <TimePicker
            placeholder={Strings.default.START_TIME + '*'}
            value={startTimeInput}
            onChange={text => onChangeStartTimeInput(text)}
            error={errorStartTime}
          />
          <TimePicker
            placeholder={Strings.default.END_TIME + '*'}
            value={endTimeInput}
            onChange={text => onChangeEndTimeInput(text)}
            error={errorEndTime}
          />
          {!showDays ? null :
          <div>
            <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: 12, marginTop: 24 }}>{Strings.default.AVAILABILITY + '*'}</p>
            {WEEKDAYS.map(d => {
              return (
                <Checkbox
                  key={d.id}
                  placeholder={d.placeholder}
                  checked={days.indexOf(d.id) !== -1}
                  onChange={() => {
                    if (days.indexOf(d.id) === -1) {
                      onChangeDays([...days, d.id])
                    } else {
                      onChangeDays(days.filter(day => day !== d.id))
                    }
                  }}
                  style={{ marginTop: 0 }}
                />
              )
            })}
          </div>
        }
        </DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: '#289e64' }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => hide()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => onDone()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

export default withStyles(Styles)(TimeModal)



// WEBPACK FOOTER //
// ./src/components/common/TimeModal/index.js